import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Account`;



const ApiAccount = {
  getAllAccount: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAllAccount`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getAllAccountSaamaneh: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAllAccountSaamaneh`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getAccountById: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAccountById?id=` + params;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getAccountByAgencyId: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAccountByAgencyId?agencyId=` + params;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  createAccount: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/createAccount`;
    console.log("url==========", url);
    return ServiceApi.post(url,  params );
  },
  updateAccount: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/updateAccount`;
    console.log("url==========", url);
    return ServiceApi.put(url, params );
  },
  changeAccountStatus: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/changeAccountStatus`;
    console.log("url==========", url);
    return ServiceApi.put(url, params );
  },
  createAccountCard: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/createAccountCard`;
    console.log("url==========", url);
    return ServiceApi.post(url,  params );
  },
  updateAccountCard: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/updateAccountCard`;
    console.log("url==========", url);
    return ServiceApi.put(url, params );
  },
  changeAccountCardStatus: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/changeAccountCardStatus`;
    console.log("url==========", url);
    return ServiceApi.put(url, params );
  },
  getAllAccountForUserId: (params) => {
    console.log("params==========",params);
    const url = `${baseServiceUrl}/getAllAccountForUserId`;
    console.log("url==========",url);

    return ServiceApi.get(url,params);
  },
};

export default ApiAccount;


